import {mapProps} from 'recompose'

import type {QueryParams} from '@jetbrains/teamcity-ui/dist/utils'
import compose from 'lodash/flowRight'
import type {ComponentProps, ComponentType} from 'react'

import Redirect from '../components/common/Redirect/Redirect'
import RouterLink from '../components/common/RouterLink/RouterLink'
import type {RouterLinkProps} from '../components/common/RouterLink/RouterLink'
import {getHrefWithQueryParams, getOverviewHref, withLocation} from '../routes'
import type {Branch} from '../services/rest'
import {BuildTypePageTabNamesEnum, stringifyId} from '../types'
import type {ActiveEntityProps, BuildId, BuildTypeId, Id, ProjectId, PipelineId} from '../types'
import {stringifyBranch} from '../utils/branchNames'

type EntityRedirectProps = ActiveEntityProps & {
  redirectedFromId?: Id
}
export const EntityRedirect: ComponentType<EntityRedirectProps> = compose(
  withLocation,
  mapProps(
    ({
      projectId,
      buildTypeId,
      buildId,
      location,
      redirectedFromId,
    }): ComponentProps<typeof Redirect> => ({
      to: getHrefWithQueryParams(
        location,
        getOverviewHref({
          projectId,
          buildTypeId,
          buildId,
        }),
        params => ({...params, redirectedFromId}),
      ),
      replace: true,
    }),
  ),
)(Redirect)
type EntityLinkProps = RouterLinkProps & {
  projectId?: ProjectId | null | undefined
  buildTypeId?: BuildTypeId | null | undefined
  pipelineId?: PipelineId | null | undefined
  runId?: string | null | undefined
  buildId?: BuildId | null | undefined
  branch?: Branch | null | undefined
  isAllProjects?: boolean
  queryParams?: QueryParams
  passQueryParameters?: boolean
}

export const getParams = (
  {branch, job, pageFullLogBuildId, edit, pipelineSettings, yaml}: QueryParams,
  isBuildTypeTab = true,
): QueryParams => ({
  branch,
  job,
  edit,
  pipelineSettings,
  yaml,
  pageFullLogBuildId,
  ...(isBuildTypeTab
    ? {
        buildTypeTab:
          branch != null && branch.length > 0
            ? stringifyId(BuildTypePageTabNamesEnum.OVERVIEW)
            : null,
      }
    : {}),
})

export default mapProps(
  ({
    projectId,
    buildTypeId,
    pipelineId,
    runId,
    buildId,
    branch,
    isAllProjects,
    passQueryParameters = true,
    queryParams,
    ...restProps
  }: EntityLinkProps): RouterLinkProps => ({
    to: getOverviewHref({
      projectId,
      buildTypeId,
      pipelineId,
      runId,
      buildId,
      isAllProjects,
    }),
    params: passQueryParameters
      ? (params: QueryParams) =>
          getParams(
            {
              ...params,
              ...queryParams,
              edit: pipelineId != null ? params.edit : undefined,
              pipelineSettings: pipelineId != null && params.edit ? 'true' : undefined,
              yaml: pipelineId != null ? params.yaml : undefined,
              branch: stringifyBranch(branch) || params.branch,
            },
            !pipelineId,
          )
      : undefined,
    ...restProps,
  }),
)(RouterLink)
